import type { LucideIcon } from "lucide-react";
import type * as React from "react";
import { forwardRef, type SVGProps } from "react";
import Skeleton from "src/components/Skeleton";
import Touchable from "src/components/Touchable";
import { cn } from "src/utilities/shadcnUtils";

export interface NavItemProps {
  children: string;
  icon?: React.FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }> | LucideIcon;
  onClick?: () => void;
  active?: boolean;
  loading?: boolean;
  iconClassName?: string;
  indicator?: boolean;
}

const NavItem = forwardRef<HTMLButtonElement, NavItemProps>(
  ({ icon: Icon, onClick, children, active, loading, iconClassName, indicator }: NavItemProps, ref) =>
    loading ? (
      <Skeleton height={58} />
    ) : (
      <Touchable
        ref={ref}
        className={cn(
          "p-2 rounded w-full flex justify-start",
          active ? "hover:bg-green-200 text-left bg-green-100" : "hover:bg-border text-left"
        )}
        onClick={onClick}
      >
        <div className="relative">
          {Icon && (
            <Icon
              width={24}
              height={24}
              className={cn(
                "min-w-[24px] min-h-[24px] mr-5",
                active ? "text-green-600" : "text-gray-500",
                iconClassName
              )}
            />
          )}
          {indicator ? (
            <div className="absolute -top-0.5 right-[16px] bg-orange rounded-full w-2 h-2 group-hover:bg-orange-700" />
          ) : null}
        </div>

        <p className={cn("font-medium text-sm", active ? "text-green-600" : "text-gray-500")}>{children}</p>
      </Touchable>
    )
);

export default NavItem;
